<template>
  <div>
    <v-card>

      <v-card-title>
        دیکته #
        {{ dictation?.id }}
        <br>
        {{ dictation?.title }}
        <br>
        تعداد سوالات :
        {{ rounds[0]?.total_question }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-subtitle>
        هنرجو :
        {{ student?.name }}
      </v-card-subtitle>
      <v-card-actions class="text-left">
        <v-row>
          <v-col class='text-left'>
              <v-icon class="back-link-icon" x-large
                      @click="$router.push('/classes/manage/item/show/'+classId+'/'+itemId+'/'+studentId)"
              >
                mdi-arrow-left
              </v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-text>
        <v-row class="mt-16 mr-16">
          <v-col cols="12" v-for="(round , index) in rounds" :key="index+'round'">
            <v-row
                :style="round.score >=75 ?  'background:#1dc51d' : round.score >=50 ?  'background-color:#46e646' : round.score >=25 ?'background-color:#f1e92f' : 'background-color:#ed5a5a' "
                class="round-row">
              <v-col cols="2">
                آزمون :
                {{ index + 1 }}
              </v-col>
              <v-col cols="2">
                امتیاز :
                {{ round.score }}
              </v-col>
              <v-col cols="2">
                تعداد سوال صحیح :
                {{ round.correct_count }}
              </v-col>
              <v-col cols="2">
                تعداد سوال غلط :
                {{ round.incorrect_count }}
              </v-col>
              <v-col cols="2">
                اخرین پاسخ :
                {{ round.latest_created_at }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

  </div>
</template>
<script>
export default {
  name: "OnlineClassDictation",
  data() {
    return {
      studentId: null,
      classId: null,
      itemId: null,
      dictationId: null,
      dictation: null,
      rounds: [],
      student: null
    }
  },
  mounted() {
    this.studentId = this.$route.params.studentId
    this.classId = this.$route.params.classId
    this.itemId = this.$route.params.itemId
    this.dictationId = this.$route.params.dictationId
    this.getDictation()
  },
  methods: {
    getDictation() {
      window.axios.get(`course/dictation/get-per-student/${this.classId}/${this.studentId}/${this.itemId}/${this.dictationId}`).then((res) => {
        this.dictation = res.data.data.general.dictation
        this.rounds = res.data.data.rounds
        this.student = res.data.data.general.student
      })
    }
  }
}
</script>
<style>
.round-row {
  margin-top: 5px;
  margin-bottom: 5px;
  border-radius: 10px;
}
</style>